<template>
  <div class="container">
    <div class="header">
      <div class="header-top" @click="orderStateShow = true">
        <div class="header-top-title">
          <van-image
            class="title-icon"
            :src="
              details.orderno
                ? details.payStatus === 3
                  ? yituikuan_icon
                  : stateMap[details.chargeStatus].img
                : ''
            "
          />
          {{
            details.orderno
              ? details.payStatus === 3
                ? "已退款" : details.chargeStatus == 0 ? payStatusOpt.find(target => target.value === details.payStatus).label
                : stateMap[details.chargeStatus].text
              : "-"
          }}
        </div>
        <div class="header-top-time">
          {{ details.createTime }} <van-icon name="arrow" />
        </div>
      </div>
      <div class="header-text">手机号码：{{ details.phone }}</div>
      <div class="header-line"></div>
    </div>

    <div class="order-box">
      <div class="order-box-shadow"></div>
      <div class="order-data-item">
        兑换金额：{{ details.faceValueCent / 100 }}元
      </div>
      <div class="order-data-item">支付类型：积分兑换</div>
      <!-- <div class="order-data-item">兑换比率：100积分=1人民币</div> -->
      <div class="order-data-item">支付数量：{{ details.pricePoint }}分</div>
      <div class="order-data-item">创建时间：{{ details.createTime }}</div>
      <div class="order-data-item">下 单 号：{{ details.sbcOrderno }}</div>
    </div>

    <div class="footer-btns">
      <van-button block round @click="$router.back()"> 我的超商联盟 </van-button>

      <van-button
        class="open-miniapp-btn"
        block
        round
        color="linear-gradient(to top, #FE0335, #FF7366)"
      >
        <div class="launch-btn"></div>
        去消费
      </van-button>
    </div>

    <img
      v-if="
        details.payStatus !== 3 &&
          (details.chargeStatus === 0 || details.chargeStatus === 4)
      "
      class="suspension-icon"
      src="../../assets/rengong_icon.png"
      alt="联系人工"
    />

    <!-- 兑换订单状态弹框 -->
    <van-popup
      v-model="orderStateShow"
      :close-on-click-overlay="false"
      style="border-radius: 10px"
    >
      <div class="dialog-box">
        <div class="dialog-head">
          兑换订单状态
          <div class="dialog-head-close" @click="orderStateShow = false">×</div>
        </div>

        <div class="dialog-con">
          <div>手机号码：{{ details.phone }}</div>
          <div class="dialog-con-state">
            <van-steps direction="vertical" active-color="#3377FF" :active="0">
              <van-step v-for="item in details.status" :key="item.status">
                <div>{{ statusMap[item.status] }}</div>
                <div class="state-time">{{ item.createTime }}</div>
              </van-step>
            </van-steps>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import api from "../../api";

const wait_icon = require("../../assets/wait_icon.png");
const succ_icon = require("../../assets/succ_icon.png");
const rengong_state_icon = require("../../assets/rengong_state_icon.png");
const yituikuan_icon = require("../../assets/yituikuan_icon.png");

export default {
  title: "超商联盟兑换详情",
  data() {
    return {
      details: {},
      stateMap: {
        0: {
          text: "兑换中",
          img: wait_icon,
        },
        2: {
          text: "成功",
          img: succ_icon,
        },
        3: {
          text: "已退款",
          img: yituikuan_icon,
        },
        4: {
          text: "待人工处理",
          img: rengong_state_icon,
        },
      },
      statusMap: {
        0: "未充值",
        1: "充值中",
        2: "充值成功",
        3: "充值失败",
        4: "人工处理",
        5: "已退款",
      },
      orderStateShow: false,
      payStatusOpt: [
        { value: 0, label: '待支付' },
        { value: 1, label: '已支付' },
        { value: 2, label: '支付失败' },
        { value: 3, label: '已退款' },
      ],
      settings: {},
    };
  },
  created() {
    this.sbcChargeOrderDetail();
    api.superBusinessCard.sbcChargeSetting(data => {
      console.log(data, "超商卡设置***");
      this.settings = data;
      const box = this.$el.querySelector(".launch-btn");
      this.wx_launch({
        ele: this.$el,
        // appid: "wx2b4c74af074f2085",
        appid: this.settings.miniProgramId,
        content: `<div class="test-btn"></div>
        <style>
        .test-btn{
            width: ${box.clientWidth}px;
            height: ${box.clientHeight}px;
          }
        </style>`,
      });
    });
  },
  mounted() {
  },
  methods: {
    is_weixn() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    is_version() {
      const wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i); // 微信浏览器信息
      // 微信正常版本号 wxInfo[1] = "8.0.1840" (示例)
      // 微信异常版本号 wxInfo[1] = "8.0.1.1840" (示例)
      //进行split转成数组进行判断 ['8','0','1','1840'] (示例)
      const version = wxInfo[1].split(".");
      // console.log('version', version);
      // 判断版本在7.0.12及以上的版本
      if (Number(version[0]) > 7) {
        return true;
      } else if (Number(version[0]) === 7) {
        if (Number(version[1]) > 0) {
          return true;
        } else if (Number(version[1]) === 0) {
          if (Number(version[2]) >= 12) return true;
        }
      }
      return false;
    },
    /* 
    {
        ele:"", // 元素ID
        appid:"", // 小程序id号 wx_****
        username: "", // gh_**** 
        url:"", // 跳转小程序的页面路径地址 例: pages/home/home.html - (后面必须带上.html后缀 否则IOS跳转时出现小程序页面未配置)
        content:"" // html字符串 例: "<button>点我</button>"
    }
  */
    wx_launch(info) {
      if (!this.is_weixn()) return;
      if (this.is_version) {
        const btn = info.ele.querySelector(".launch-btn"); //获取元素
        const script = document.createElement("script"); // 创建script内容插槽 避免template标签冲突
        script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
        script.text = info.content; // 自定义的html字符串内容
        const html = `<wx-open-launch-weapp
                      style="display: block;width: 100%;height: 100%" 
                      appid="${info.appid}">${script.outerHTML}</wx-open-launch-weapp>`;
        btn.innerHTML = html; // html字符串赋值
      } else {
        alert("您的版本号不支持");
      }
    },
    toUrl(url) {
      this.$routerPush(this, url);
    },
    sbcChargeOrderDetail() {
      api.superBusinessCard.sbcChargeOrderDetail(
        {
          orderno: this.$route.query.orderno || "",
        },
        data => {
          console.log(data, "超商卡兑换详情****");
          this.details = data.record;
        },
        err => {
          this.$toast(err.msg);
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
.open-miniapp-btn {
  position: relative;
  .launch-btn {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
.container {
  min-height: 100vh;
  background-color: #f9f9f9;
  .header {
    padding: 6.67vw 4vw;
    background-color: #3377ff;
    color: #fff;

    .header-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .header-top-title {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 4.27vw;
        .title-icon {
          width: 7vw;
          margin-right: 2.67vw;
        }
      }
      .header-top-time {
        display: flex;
        align-items: center;
        font-size: 3.5vw;
      }
    }
    .header-text {
      margin-top: 4vw;
      font-size: 3.47vw;
    }
    .header-line {
      margin-top: 6.67vw;
      height: 1.87vw;
      border-radius: 0.93vw;
      background-color: rgba(0, 0, 0, 0.2);
    }
  }

  .order-box {
    position: relative;
    margin: 0 5.6vw;
    margin-top: -7.6vw;
    padding: 6.67vw 5.33vw;
    background-color: #fff;
    border-radius: 0.53vw 0.53vw 1.33vw 1.33vw;
    box-shadow: 0 0 0.27vw rgba(200, 200, 200, 0.3);

    .order-box-shadow {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 4vw;
      background-image: linear-gradient(
        to bottom,
        rgba(50, 200, 255, 0.4) 0%,
        rgba(50, 200, 255, 0) 100%
      );
    }
    .order-data-item {
      & + .order-data-item {
        margin-top: 4.67vw;
      }
    }
  }

  .footer-btns {
    display: flex;
    justify-content: center;
    margin: 3vw auto;
    margin-top: 10vw;
    .van-button {
      width: 40%;
      margin: 0 2%;
    }
  }

  .suspension-icon {
    position: fixed;
    right: 2.67vw;
    top: 50%;
    transform: translateY(-50%);
    width: 15vw;
    height: 15vw;
    border-radius: 50%;
  }

  .dialog-box {
    width: 80vw;
    border-radius: 2.67vw;
    .dialog-head {
      padding: 4.53vw;
      padding-bottom: 5vw;
      text-align: center;
      font-weight: 600;
      font-size: 4.27vw;
      .dialog-head-close {
        position: absolute;
        top: 2vw;
        right: 4vw;
        font-size: 7vw;
        color: #999;
        font-weight: normal;
      }
    }
    .dialog-con {
      padding: 0 4vw;
      .dialog-con-state {
        padding: 2.67vw 0 5vw;
        .state-time {
          margin-top: 2vw;
          font-size: 3.47vw;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/superBusinessCard/ExchangeDetails.vue